




import { Vue, Prop, Component } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SkeletonAnimation extends Vue {
  @Prop() maxWidth: 100;
  @Prop() minWidth: 80;
  @Prop() height: "1em";
  @Prop() width: "100px";
}
